class Inspection {
	id = null;
	name = '';
	activity_description = '';
	due_date = null;
	closed = false;
	inspection_frequency_id = null;
	equipment_id = null;
	uploaded_files = [
		{
			name: '',
			link: '',
			original_name: '',
			upload_id: null,
		},
	];

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Inspection;
